import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "box d-flex flex-column align-items-center justify-content-center"
}
const _hoisted_2 = { class: "d-flex flex-column gap-4 w-fit-content bg-black" }
const _hoisted_3 = { class: "title-container d-flex flex-row gap-4 justify-content-center align-items-center" }
const _hoisted_4 = { class: "titleLabel" }
const _hoisted_5 = { class: "priceBox d-flex flex-row justify-content-center align-items-center" }
const _hoisted_6 = { class: "d-flex flex-column justify-content-center align-items-center text-nowrap" }
const _hoisted_7 = { class: "amount" }
const _hoisted_8 = { class: "bb-container d-flex flex-column align-items-center justify-content-sm-between" }
const _hoisted_9 = { class: "d-flex flex-row align-items-center justify-content-center" }
const _hoisted_10 = { class: "d-flex flex-row align-items-center justify-content-center" }
const _hoisted_11 = ["src"]
const _hoisted_12 = ["onMouseenter"]
const _hoisted_13 = {
  key: 0,
  class: "item lightning"
}
const _hoisted_14 = ["src"]

import FaceBox from "@/components/Common/FaceBox.vue";
import TechnoFrame from "@/components/Common/TechnoFrame.vue";

import { defineComponent } from 'vue'
import store from "@/store";
import {PassProperties} from "@/components/RegistrationPage/Card/PassProperties";

const __default__ = defineComponent({
    name: 'SelectedBonusesDisplay2',

    data() {
        return {
            state: store.state,
        }
    },

    computed: {
        selectedPass(): PassProperties | null
        {
            return this.state.selectedPass
        },

        includedPassesCount(): number
        {
            const selectedPass = this.selectedPass
            if (!selectedPass) {
                return 0
            }

            let count = 0
            this.state.passes.forEach((_, i) => {
                if (i <= (selectedPass.level ?? 0)) {
                    count++
                }
            })

            return count
        },
    },
})


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

_useCssVars(_ctx => ({
  "15bfa041": (`url("/img/page/landing/registration/cardBg/${_ctx.selectedPass.background}.webp")`)
}))


return (_ctx: any,_cache: any) => {
  return (_ctx.selectedPass)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(TechnoFrame, {
          offset: 8,
          "size-modifier": 0.3
        }),
        _createElementVNode("p", {
          class: "label",
          style: _normalizeStyle({
                borderColor: _ctx.selectedPass.glowColor,
                // color: selectedPass.glowColor,
                // color: 'white',
                // boxShadow: `0 0 5px 1px ${selectedPass.glowColor}`,
            })
        }, [
          _createElementVNode("span", null, [
            _cache[1] || (_cache[1] = _createTextVNode("Пропуск ")),
            _createElementVNode("b", {
              style: _normalizeStyle({color: _ctx.selectedPass.labelColor,})
            }, "«" + _toDisplayString(_ctx.selectedPass.name) + "»", 5),
            _cache[2] || (_cache[2] = _createTextVNode(" содержит:"))
          ])
        ], 4),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.selectedPass.title), 1),
            _createElementVNode("div", _hoisted_5, [
              _cache[4] || (_cache[4] = _createElementVNode("img", {
                class: "icon",
                src: `/img/page/landing/registration/icon/galacoin.png`
              }, null, -1)),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.selectedPass.galacoinAmount.toLocaleString('ru').replace(/\u00A0/g, ' ')), 1),
                _cache[3] || (_cache[3] = _createElementVNode("span", { class: "currency" }, "галакоинов", -1))
              ])
            ])
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["bonuses d-flex flex-row align-items-center justify-content-center flex-wrap", [
                    `count-${_ctx.includedPassesCount}`,
                    {
                        large: _unref(store).state.pageSize.width >= 1600,
                        medium: _unref(store).state.pageSize.width >= 1280,
                        small: _unref(store).state.pageSize.width < 1280,
                    }
                ]])
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.passes, (pass) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: pass.code
              }, [
                (pass.level <= _ctx.selectedPass.level)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "bonusBox",
                      style: _normalizeStyle({
                            borderColor: pass.glowColor,
                            boxShadow: `0 0 5px 1px ${pass.glowColor}`,
                        })
                    }, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", {
                          class: "background",
                          style: _normalizeStyle({
                                    backgroundImage: `url('/img/page/landing/registration/cardBg/${pass.background}.webp')`,
                                })
                        }, null, 4),
                        _createElementVNode("span", null, [
                          _cache[5] || (_cache[5] = _createTextVNode("Все бонусы пропуска ")),
                          _createElementVNode("span", {
                            style: _normalizeStyle({color: pass.labelColor})
                          }, "«" + _toDisplayString(pass.name) + "»", 5)
                        ]),
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("div", _hoisted_10, [
                            _createVNode(FaceBox, {
                              size: 140,
                              face: pass.avatar.image,
                              frame: pass.frame.image
                            }, null, 8, ["face", "frame"]),
                            _createElementVNode("img", {
                              class: _normalizeClass(["ship", {
                                            flipped: pass.code === 'WHITE_PASS'
                                        }]),
                              src: `/img/page/landing/registration/ship/${pass.ship.image}`
                            }, null, 10, _hoisted_11)
                          ])
                        ]),
                        _createElementVNode("ul", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pass.bonuses, (bonus, i) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: i,
                              onMouseenter: ($event: any) => (_ctx.state.passBonus = bonus),
                              onMouseleave: _cache[0] || (_cache[0] = ($event: any) => (_ctx.state.passBonus = null))
                            }, [
                              (bonus.image === 'boosts')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_13, _cache[6] || (_cache[6] = [
                                    _createElementVNode("svg", {
                                      class: "item-icon lightning-icon",
                                      viewBox: "0 0 24 24"
                                    }, [
                                      _createElementVNode("path", {
                                        d: "M7 2v11h3v9l7-12h-4l4-8z",
                                        fill: "#fff176"
                                      })
                                    ], -1)
                                  ])))
                                : (_openBlock(), _createElementBlock("img", {
                                    key: 1,
                                    class: "itemIcon",
                                    src: `/img/page/landing/registration/item/${bonus.image}.png`
                                  }, null, 8, _hoisted_14)),
                              _createElementVNode("span", null, _toDisplayString(bonus.name), 1)
                            ], 40, _hoisted_12))
                          }), 128))
                        ])
                      ])
                    ], 4))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128))
          ], 2)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})